import { render, staticRenderFns } from "./CarouselSides.vue?vue&type=template&id=d0aa7852&"
import script from "./CarouselSides.vue?vue&type=script&lang=js&"
export * from "./CarouselSides.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports